module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_dwarven.719780ff.jpg";